import { render, staticRenderFns } from "./AccountContentList.vue?vue&type=template&id=5d798974&scoped=true"
import script from "./AccountContentList.vue?vue&type=script&lang=js"
export * from "./AccountContentList.vue?vue&type=script&lang=js"
import style0 from "./AccountContentList.vue?vue&type=style&index=0&id=5d798974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d798974",
  null
  
)

export default component.exports